/**
 * Popover for dynamically inserted elements
 * @requires https://getbootstrap.com
 * @requires https://popper.js.org/
 */

export default (() => {
  const initializePopover = (element) => {
    new bootstrap.Popover(element)
  }

  const observePopovers = () => {
    const popoverContainer = document.body

    // Initialize popovers for any existing elements
    document
      .querySelectorAll('[data-bs-toggle="popover"]')
      .forEach(initializePopover)

    // Observe for newly added elements
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (
            node.nodeType === 1 &&
            node.matches('[data-bs-toggle="popover"]')
          ) {
            initializePopover(node)
          } else if (node.nodeType === 1) {
            node
              .querySelectorAll('[data-bs-toggle="popover"]')
              .forEach(initializePopover)
          }
        })
      })
    })

    observer.observe(popoverContainer, { childList: true, subtree: true })
  }

  observePopovers()
})()
